module.exports = __webpack_public_path__ + "img/goods-3.29a7c97b.png";